"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var body_html_1 = __importDefault(require("./body.html"));
require("./body.less");
require("./print.less");
(function (module) {
    'use strict';
    var BODY_SELECTOR = '.pr-body';
    var FIXED_CLASS = 'fixed';
    var PAGE_BREAK_WIDGET_TYPE = 'pr.pagebreak';
    var FIRST_PAGE_HEADSTART = 3000;
    BodyController.$inject = [
        '$q',
        '$scope',
        '$timeout',
        '$routeParams',
        '$filter',
        'rsWidgets',
        'prActiveReport',
        'prFlowingPages',
        'prKeylogService',
        'prPageLayoutService',
        'prScrollService',
        'pr.EVENTS',
        'prEventService',
        'rsEnvironment',
        'prPartialDataService',
        'prWidgetInit',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'prAutoHeightHelper',
        'pr.widgetStylesService',
        'prWidgetCountLimitWarningModal',
        'prMetricsService',
        'pr.widgetOperationsService',
        'prCustomWidgetService',
        'pr.uiPagesManager',
        'pr.navigationService',
        'pr.editUIManager',
        'pr.widgetCountWarningBannerService',
        'prWidgetLimitService'
    ];
    function BodyController($q, $scope, $timeout, $routeParams, $filter, rsWidgets, report, flowingPages, keylog, pageLayout, scrollService, EVENTS, eventService, env, partialDataService, widgetInit, triggerOverrides, OVERRIDE_EVENTS, autoHeightHelper, widgetStylesService, prWidgetCountLimitWarningModal, metricsService, widgetService, customWidgetService, pagesManager, navigationService, editUIManager, widgetCountWarningBannerService, prWidgetLimitService) {
        var $ctrl = this;
        var translate = $filter('translate');
        var configFlags = triggerOverrides({
            event: OVERRIDE_EVENTS.CONFIG_FLAGS,
            sync: true,
            data: {}
        });
        $ctrl.showLanguagePicker = !navigationService.isParticipantPreview;
        var permissions = env.get('permissions');
        var isBatchGenerationInProgress = env.get('isBatchReportGenerationInProgress');
        angular.extend($ctrl, {
            activePage: 0,
            // there is only ever one "active" widget (showing options)
            activeWidgetId: null,
            // If the server has returned the container env variable, then the public report can be viewed
            canViewPublicReport: env.get('container') ? true : false,
            // multiple widgets (or widget chunks) can be selected
            selectionIds: [],
            visiblePages: $routeParams.showAllPages ? Infinity : 1,
            configFlags: configFlags,
            enableSharing: !configFlags.disableSharing && (permissions || {}).enablePublicReport,
            showExportButton: !navigationService.isParticipantPreview,
            isBatchGenerationInProgress: isBatchGenerationInProgress,
            $onInit: function () {
                // let's do this next time around, to give time for initialization
                $timeout(function () {
                    keylog.registerAction([keylog.CTRL, keylog.SHIFT, keylog.BACKSPACE], $ctrl.deleteWidgets);
                    keylog.registerAction([keylog.CTRL, keylog.SHIFT, keylog.DELETE], $ctrl.deleteWidgets);
                    keylog.registerAction([keylog.CTRL, keylog.ENTER], $ctrl.insertPageBreak);
                    keylog.registerAction([keylog.CTRL, keylog.C], $ctrl.copyWidgets);
                    keylog.registerAction([keylog.CTRL, keylog.V], $ctrl.pasteWidgets);
                    keylog.registerAction(keylog.ESC, function () {
                        // deselect all the widgets
                        selectWidgets();
                    });
                    eventService.on('widgetSwitch', switchWidget);
                    eventService.on('widgetDeleted', function () {
                        // deselect all the widgets
                        selectWidgets();
                    });
                    eventService.on('deselectWidgets', function () {
                        // deselect all the widgets
                        selectWidgets();
                    });
                    eventService.on('copyWidget', function () {
                        $ctrl.copyWidgets();
                    });
                    eventService.on(EVENTS.REPORT_LANGUAGE_CHANGED, function () {
                        selectWidgets();
                    });
                    var top = $(BODY_SELECTOR).offset().top;
                    scrollService.onScroll(function (evt, down) {
                        if (down) {
                            $(BODY_SELECTOR).addClass(FIXED_CLASS);
                        }
                        else {
                            $(BODY_SELECTOR).removeClass(FIXED_CLASS);
                        }
                    }, top);
                    if (isBatchGenerationInProgress) {
                        editUIManager.disableEditUI();
                    }
                });
                // Add extra visible page after a delay - give the first page a headstart
                $timeout(function () {
                    $ctrl.visiblePages += 1;
                }, FIRST_PAGE_HEADSTART);
            },
            $onDestroy: function () {
                keylog.deregisterAction([keylog.CTRL, keylog.SHIFT, keylog.BACKSPACE], $ctrl.deleteWidgets);
                keylog.deregisterAction([keylog.CTRL, keylog.SHIFT, keylog.DELETE], $ctrl.deleteWidgets);
            },
            setActivePage: function (pageIdx) {
                $ctrl.activePage = pageIdx;
            },
            /*
             * The interactingPages are where widgets are moving from,
             * and should not get unloaded while the widgets are moving
             */
            setInteractingPages: function (pageIdxs) {
                $ctrl.interactingPages = pageIdxs;
            },
            setVisiblePages: function (count) {
                $ctrl.visiblePages = count;
            },
            addWidgetToActivePage: function (type, optBefore, sourceId, fieldId) {
                return addWidget(type, null, { before: optBefore }, sourceId, fieldId);
            },
            copyWidgets: function () {
                $ctrl.copiedWidgetIds = _.map($ctrl.selectionIds, getWidgetIdFromSelectionId);
                _.forEach($ctrl.copiedWidgetIds, function (widgetId) {
                    metricsService.visualizationCopy(flowingPages.getWidget(widgetId));
                });
            },
            pasteWidgets: function () {
                var toCopy = $ctrl.copiedWidgetIds || [];
                if (!toCopy.length || flowingPages.hasReachedWidgetLimit()) {
                    return;
                }
                var pivotWidget = getPivotWidget();
                return widgetService.copyWidgets(toCopy, pivotWidget).then(function (widgets) {
                    handleNewWidget(widgets[0]);
                    return widgets;
                });
            },
            deleteWidgets: function () {
                // selected widgets are about to be deleted
                // so remove them from the copied widget list
                $ctrl.copiedWidgetIds = _.difference($ctrl.copiedWidgetIds, $ctrl.selectionIds);
                var widgetIds = _.map($ctrl.selectionIds, getWidgetIdFromSelectionId);
                widgetService.deleteWidgets(widgetIds);
                // deselect all the widgets
                selectWidgets();
            },
            getSizeClassName: function () {
                return pageLayout.getSize() + ' ' + pageLayout.getOrientation();
            },
            insertPageBreak: function () {
                // Disable page break functionalty when the user action
                // will add a pb to the top of the first page
                if (!$ctrl.activeWidgetId) {
                    var page = flowingPages.getPages()[$ctrl.activePage];
                    if (!page.widgets || !page.widgets.length) {
                        return;
                    }
                }
                addWidget(PAGE_BREAK_WIDGET_TYPE);
            },
            removePageBreak: function (pageBreakId) {
                return widgetService.deleteWidgets(pageBreakId);
            },
            /*
             * This method selects a single widget and makes sure it shows the resizer
             * @param (string) id - a selectionId in the format of "widgetId.chunkIndex"
             */
            selectWidget: function (id) {
                $ctrl.selectWidgets([id]);
            },
            /*
             * This method selects a set of widgets and makes sure it shows the resizer
             * @param (array<string>) ids - an array of selectionIds in the format of "widgetId.chunkIndex"
             */
            selectWidgets: selectWidgets,
            /*
             * Returns true if there are some widgets in the current selection
             */
            hasSelectedWidgets: function () {
                return ($ctrl.selectionIds || []).length;
            },
            selectAndScrollToWidget: selectAndScrollToWidget,
            switchWidget: switchWidget,
            $digest: function () {
                $scope.$digest();
            },
            showReport: function () {
                return !$ctrl.isPublic || $ctrl.canViewPublicReport;
            },
            showPartialDataBanner: function () {
                return $ctrl.showReport() && partialDataService.usingPartialData();
            },
            shouldShowWidgetCountWarningBanner: function () {
                return widgetCountWarningBannerService.shouldShow();
            }
        });
        function addWidget(type, optLayout, optOptions, sourceId, fieldId) {
            if (optOptions === void 0) { optOptions = {}; }
            if (flowingPages.hasReachedWidgetLimit()) {
                return;
            }
            var page = report.getPages()[0];
            if (!page) {
                return;
            }
            var hasField = sourceId && fieldId;
            var layout = _.defaults(optLayout || {}, getDefaultLayout(type, hasField));
            var pivot = getPivotWidget();
            widgetService.addWidget(type, layout, pivot, optOptions).then(function (widget) {
                widgetInit.addNewWidget(widget._id);
                // filer summary widget need to apply alignment: center upon init
                if (type === 'pr.filtersummary') {
                    widgetStylesService.applyAllWidgetStyles(widget);
                }
                handleNewWidget(widget, optOptions);
            });
        }
        function handleNewWidget(widget, optOptions) {
            if (optOptions === void 0) { optOptions = {}; }
            if (!optOptions.disableSelect) {
                $timeout(function () {
                    selectAndScrollToWidget(widget);
                });
            }
            var widgetCountLimit = prWidgetLimitService.getWidgetLimit();
            // pop up warning modal when widget count reaches threshold (widgetCountLimit - 5)
            if (!_.isUndefined(widgetCountLimit)) {
                var widgetCount = flowingPages.getWidgetsCount();
                if (widgetCount === widgetCountLimit - 5) {
                    var title = translate('PR.WIDGET_COUNT_NEARING_LIMIT_WARNING');
                    var info = translate('PR.WIDGET_COUNT_NEARING_LIMIT_INFO', {
                        widgetCountLimit: widgetCountLimit
                    });
                    prWidgetCountLimitWarningModal.show(title, info);
                }
            }
        }
        function getPivotWidget() {
            if ($ctrl.activeWidgetId) {
                // it is an ID so we want to get it
                return flowingPages.getWidget($ctrl.activeWidgetId);
            }
            // we don't have a widget to insert after, so put it after the last widget on the active page
            return pagesManager.getPivotWidget($ctrl.activePage);
        }
        function selectAndScrollToWidget(widget) {
            if (widget && widget._type !== PAGE_BREAK_WIDGET_TYPE) {
                var selId = getSelectId(widget);
                selectWidgets([selId]);
                scrollToWidget(widget);
            }
            else {
                $ctrl.activeWidgetId = null;
            }
        }
        function getSelectId(widget) {
            var selId = widget._id;
            if (widget.chunks) {
                selId += '.0'; // select the first chunk
            }
            return selId;
        }
        /**
         * selectWidgets
         * when selectionIds is null, this function works as deselect widgets
         * @param  {array} selectionIds
         */
        function selectWidgets(selectionIds) {
            var prevActive = $ctrl.activeWidgetId;
            $ctrl.selectionIds = selectionIds || [];
            $ctrl.activeWidgetId = null;
            // if there is only one, then we can select an active widget
            if ($ctrl.selectionIds.length === 1) {
                $ctrl.activeWidgetId = getWidgetIdFromSelectionId($ctrl.selectionIds[0]);
            }
            // we have to set undefined to remove it rather than null
            env.set('selectedWidgetId', $ctrl.activeWidgetId || undefined);
            if (prevActive !== $ctrl.activeWidgetId) {
                if (prevActive) {
                    eventService.stream(prevActive).trigger('deselect');
                }
                if ($ctrl.activeWidgetId) {
                    eventService.stream($ctrl.activeWidgetId).trigger('select');
                }
            }
            eventService.trigger('widgetsSelected');
        }
        function getWidgetIdFromSelectionId(sId) {
            return sId.split('.')[0];
        }
        function getDefaultLayout(type, hasField) {
            // set a full-size colSpan for a new added widget
            var defaultColSpan = pageLayout.getCols();
            var rowSpan = Math.round(defaultColSpan / 3);
            // when inserting a chunk widget from survey data,
            // we need to make sure that the widget below it will not be pushed
            // to a new page before all chunks got rendered. Or it will cause a
            // data rendering issue.
            // Therefore, a zero rowSpan would guarantee the widget below it would
            // still stay on the current page.
            // For more details, please refer to:
            // https://gitlab-app.eng.qops.net/printed-reports/printed-reports-client/merge_requests/383
            if (autoHeightHelper.isAutoHeightSupported(type) && hasField) {
                rowSpan = 0;
            }
            var defaultLayout = {
                row: 0,
                col: 0,
                colSpan: defaultColSpan,
                rowSpan: rowSpan,
                style: __assign(__assign({}, customWidgetService.getDefaultWidgetStyle(type)), { enableAltRows: (type === 'eng.grid') })
            };
            if (type === 'pr.filtersummary') {
                defaultLayout.style.filterSummaryTextFormats = {
                    ALIGNMENT: {
                        ALIGNMENT: 'center'
                    }
                };
            }
            return defaultLayout;
        }
        function scrollToWidget(widget) {
            $timeout(function () {
                scrollService.scrollTo('#' + widget._id);
            });
        }
        function switchWidget(event, newType) {
            if (!$ctrl.activeWidgetId) {
                return;
            }
            eventService.stream($ctrl.activeWidgetId).trigger('hideWidget');
            var activeWidget = flowingPages.getWidget($ctrl.activeWidgetId);
            var activeWidgetId = activeWidget._id;
            var activeWidgetType = activeWidget._type;
            var pageId = report.getPageIdOfWidget(activeWidget);
            metricsService.changeVisualizationType(activeWidgetType, newType);
            // deslect and reselect to update sidebar
            selectWidgets(); // not using deleteWidget as it triggers a digest
            $timeout(function () {
                // Destroy the widget
                rsWidgets.unload(activeWidget, pageId);
                activeWidget = flowingPages.switchWidget(activeWidgetId, newType);
                $timeout(function () {
                    var selId = getSelectId(activeWidget);
                    selectWidgets([selId]);
                });
            });
        }
    }
    module.component('prBody', {
        templateUrl: body_html_1.default,
        controller: BodyController,
        bindings: {
            isPublic: '<',
            isExport: '<'
        }
    });
}(angular.module('qualtrics.pr')));
